import React from 'react';
import { SvgIcon } from '@progress/kendo-react-common';
import { infoCircleIcon } from '@progress/kendo-svg-icons';
import { useGlobalizationContext, useTranslation } from '@cs-cms/state-management';

export const FacetCountInfo: React.FC = () => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  return (
    <div className="facetCountInfo">
      <SvgIcon icon={infoCircleIcon} className="facetCountInfoIcon" />
      <div className="facetCountInfoContent">
        <p>{translate('custom.settings.views.facetCountInformation')}</p>
      </div>
    </div>
  );
};
